
class Tax {
  zipcode = "";
  amount = 0;
  taxRequestPending = false;
  enableCheckoutZip = true;
};

export default Tax;
